// themes/tealDominantTheme.ts
import { createTheme } from "@mui/material/styles";

export const tealDominantTheme = createTheme({
    palette: {
        mode: "light",
        background: {
            default: "#4A7C9D", // xanh dương nhạt
            paper: "rgba(255, 255, 255, 0.15)",
        },
        primary: {
            main: "#3CA3A3", // teal chính
        },
        secondary: {
            main: "#D48C3B", // accent cam
        },
        text: {
            primary: "#0F2A3D",   // xanh đậm
            secondary: "#3CA3A3", // teal nhấn
        },
    },

    shape: {
        borderRadius: 12,
    },

    typography: {
        fontFamily: '"Orbitron", sans-serif',
        button: {
            textTransform: "uppercase",
            fontWeight: 700,
            fontSize: "0.9rem",
        },
    },

    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: "#4A7C9D",
                    backgroundImage: `linear-gradient(rgb(8 10 81 / 74%), rgb(26 66 93 / 81%)), url(/assets/community_background.png)`,
                    // backgroundImage: `linear-gradient(rgb(8 10 81 / 74%), rgb(74 124 157 / 81%)), url('/assets/community_background.png')`,
                    // backgroundImage: `linear-gradient(rgb(8 10 81 / 74%), rgb(29 66 90 / 81%)), url(/assets/community_background.png)`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    backgroundSize: 'cover',

                    " & .MuiSideBar": {
                        position: "relative",
                        borderRadius: "12px",
                        backgroundColor: 'rgba(31,74,99,0.65)', // xanh navy translucent
                        padding: "16px",
                        width: "100%",
                        maxWidth: "100%",
                        // color: "#FFFFFF",
                        margin: "0 auto 20px",
                        " & .titleBox": {
                            display: "flex",
                            justifyContent: "center",
                            backgroundColor: "rgba(255, 255, 255, 0.65)",
                            borderRadius: "8px",
                            padding: "6px 16px",
                            width: "100%",
                            marginBottom: "16px",
                            " & .titleText": {
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                color: "#3CA3A3", // teal highlight
                                letterSpacing: "1px",
                                fontSize: "1rem",
                            }
                        }
                    },

                    " & .MuiMessage": {
                        padding: 24,
                        textAlign: "center",
                        borderRadius: "12px",
                        color: "white",
                        fontFamily: '"Orbitron", sans-serif',
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        letterSpacing: "1px",
                    },

                    "& .CenterButton": {
                        minWidth: "100px",
                        height: "160px",
                        borderRadius: "50%",
                        background: "radial-gradient(circle at 50% 50%, #7BC7C7, #4A7C9D)",
                        border: "2px solid #3CA3A3",
                        boxShadow: "0 6px 18px rgba(31,74,99,.35)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transition: "all 0.25s ease",
                        padding: 0,
                        "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 12px 24px rgba(31,74,99,.45)",
                            "& .MuiSvgIcon-root": {
                                color: "#3CA3A3",
                                filter: "drop-shadow(0 0 8px rgba(60,163,163,0.6))",
                            },
                        },
                        "& .MuiSvgIcon-root": {
                            fontSize: "64px",
                            color: "#0F2A3D",
                            transition: "all 0.4s ease",
                        },
                    },
                    " .background-transparent": {
                        background: "transparent!important"
                    }
                },
                "*": {
                    boxSizing: "border-box",
                },
            },
        },

        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    "&.muiButtonIcon": {
                        fill: "#D4AF37"
                    },
                }
            }
        },

        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    fontWeight: "bold",
                    fontFamily: '"Orbitron", sans-serif',
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // backgroundColor: "rgb(140 191 227 / 82%)",
                    backgroundColor: "rgb(177 196 209)",
                    color: "#1c2e50",
                    boxShadow: "0 0 6px rgba(31,74,99,0.4)",
                    " &.muiButtonIcon": {
                        fill: "red"
                    },
                    "&:hover": {
                        backgroundColor: "#5581a0",
                        color: "white",
                        boxShadow: "0 0 12px #5581a0",
                    },
                    "&:active": {
                        transform: "scale(0.98)",
                    },
                    "&.active": {
                        backgroundColor: "#2c346c", // xanh navy khi active
                        color: "white",
                        boxShadow: "0 0 12px #2c346c",
                        " &.muiButtonIcon": {
                            fill: "white"
                        }
                    }
                },
            },
        },

        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(255,255,255,0.2)",
                    borderRadius: 12,
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#3CA3A3",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#1F4A63",
                        boxShadow: "0 0 6px #1F4A63",
                    },
                    input: {
                        color: "#0F2A3D",
                    },
                },
            },
        },

        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    // backgroundColor: "rgba(255, 255, 255, 0.1)",
                    borderRadius: 16,
                    backdropFilter: "blur(6px)",
                    boxShadow: "0 0 6px rgba(31,74,99,0.2)",
                },
            },
        },

        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 16,
                    backdropFilter: "blur(10px)",
                    backgroundColor: "rgba(255, 255, 255, 0.75)",
                    boxShadow: "0 0 16px rgba(31,74,99,0.6)",
                    padding: '16px 24px',
                    color: "#0F2A3D",
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    fontWeight: 700,
                    fontSize: "1.25rem",
                    color: "#1F4A63",
                },
            },
        },

        MuiTypography: {
            styleOverrides: {
                root: {
                    color: "#0F2A3D",
                },
            },
        },

        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: "#616ead", // teal đậm → contrast rõ với nền
                    color: "#FFFFFF",
                }
            }
        },

        MuiListItemText: {
            styleOverrides: {
                primary: {
                    fontFamily: '"Orbitron", sans-serif',
                    fontSize: "0.95rem",
                    color: "#0F2A3D",
                },
            },
        },
    },
});
